<template>
  <div>
    <transition name="fade" mode="out-in">
      <car-brand
        v-if="carData.TYPENUMBER === 1"
        @change-type="showRightTable"
      ></car-brand>
      <car-series
        v-else-if="carData.TYPENUMBER === 2"
        :brand-id="carData.brandId"
        @change-type="showRightTable"
      ></car-series>
      <car-model
        v-else
        :series-id="carData.seriesId"
        :brand-id="carData.brandId"
        @change-type="showRightTable"
      ></car-model>
    </transition>
  </div>
</template>

<script>
// 组件
import carBrand from './carBrand'
import carSeries from './carSeries'
import carModel from './carModel'

import { TYPENUMBER } from '@/api/system/carBrand'

export default {
  name: 'brand',
  components: { carBrand, carSeries, carModel },
  data() {
    return {
      carData: {
        TYPENUMBER,
      },
    }
  },
  methods: {
    showRightTable(data) {
      this.carData = { ...data }
    },
  },
}
</script>

<style lang='scss' scoped>
.fade-enter-active,
.fade-leave-active {
  transition: all 0.5s linear;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
